import { useEffect } from "react";
import {
  useSearchBarcode,
  useSetPosOrderSearch
} from "../atoms/usePosOrderSearchAtom";
import { barcodePattern } from "../utils/patterns";
import useModal from "../atoms/useModal";
import useCategoryQueryHook from "./useCategoryQueryHook";
import { useAddCartItem } from "./useCartHook";

const useScanBarcodeHook = () => {
  const [{ type: modalType }, setModal] = useModal();
  const { products } = useCategoryQueryHook();
  const setBarcode = useSetPosOrderSearch();
  const barcode = useSearchBarcode();
  const addCartItem = useAddCartItem();
  const setPosOrderSearch = useSetPosOrderSearch();

  useEffect(() => {
    let barcode = "";
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        if (barcodePattern.test(barcode)) {
          setPosOrderSearch((draft) => {
            draft.barcode = barcode;
          });
        }
        barcode = "";
      } else {
        if (modalType === "printReceipt" || modalType === "printSessionReceipt")
          setModal({ type: "", meta: {} });
        barcode += e.key;
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (barcode && barcodePattern.test(barcode)) {
      const product = products.find((product) =>
        product.barcode?.includes(barcode)
      );
      if (product) {
        addCartItem({ ...product, quantity: 1 });
        setBarcode((draft) => {
          draft.barcode = "";
        });
      }
    }
  }, [barcode, products]);
};

export default useScanBarcodeHook;
